'use client';

import React from 'react';



export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ margin: 0, fontFamily: 'sans-serif', background: '#FDF6E3', color: '#1A2E1A' }}>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          {/* Flag accent top */}
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 4, display: 'flex' }}>
            <div style={{ flex: 1, background: '#1B6B3A' }} />
            <div style={{ flex: 1 }} />
            <div style={{ flex: 1, background: '#1B6B3A' }} />
          </div>

          <div style={{ maxWidth: 360, width: '100%' }}>
            {/* Logo */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
              <div style={{ width: 64, height: 64, borderRadius: 16, background: 'rgba(27,107,58,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src="/assets/images/76FA5DEB-6D41-4DAD-A034-98609AD757A2-1787860809045.png"
                  alt="Naija Explorer"
                  width={44}
                  height={44}
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </div>

            <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, color: '#1A2E1A' }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: 14, color: '#6B7B5E', lineHeight: 1.6, marginBottom: 28 }}>
              An unexpected error occurred. Your progress is safe. Please try again or return to the home page.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <button
                onClick={reset}
                style={{
                  background: '#1B6B3A',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 12,
                  padding: '14px 24px',
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: 'pointer',
                  minHeight: 48,
                }}
              >
                Try Again
              </button>
              <a
                href="/"
                style={{
                  background: 'transparent',
                  color: '#1B6B3A',
                  border: '2px solid #1B6B3A',
                  borderRadius: 12,
                  padding: '12px 24px',
                  fontSize: 15,
                  fontWeight: 600,
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 48,
                }}
              >
                Back to Home
              </a>
            </div>
          </div>

          {/* Flag accent bottom */}
          <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: 4, display: 'flex' }}>
            <div style={{ flex: 1, background: '#1B6B3A' }} />
            <div style={{ flex: 1 }} />
            <div style={{ flex: 1, background: '#1B6B3A' }} />
          </div>
        </div>
      </body>
    </html>
  );
}
